<template>
  <div class="sizeapp__holder">
    <!-- Help & support -->
    <transition name="sizeAppFade" mode="out-in">
      <div key="hulp" class="sizeapp__pane" v-if="hulp">
        <!-- Header -->
        <div class="sizeapp__header" @click="toggleHulp()">
          <span class="sizeapp__header__button"
            >&lsaquo;</span
          >
          <strong class="sizeapp__header__title">{{
            $t('helpAndSupport')
          }}</strong>
        </div>

        <div class="sizeapp__pane__holder">
          <!-- Section -->
          <div class="sizeapp__pane__header">
            <strong>{{ $t('moreInfoTitle') }}</strong>
          </div>
          <div class="sizeapp__pane__content">
            {{ $t('moreInfoSubTitle') }}
          </div>

          <strong> {{ $t('moreInfoWhatToMeasure') }} </strong>

          <!-- Section -->
          <div class="sizeapp__pane__header">
            <strong>{{ $t('moreInfoBodyLengthTitle') }}</strong>
          </div>
          <div class="sizeapp__pane__content">
            <ul>
              <li>{{ $t('moreInfoBodyLengthStep1') }}</li>
              <li>{{ $t('moreInfoBodyLengthStep2') }}</li>
              <li>{{ $t('moreInfoBodyLengthStep3') }}</li>
              <li>{{ $t('moreInfoBodyLengthStep4') }}</li>
              <li>{{ $t('moreInfoBodyLengthStep5') }}</li>
            </ul>
          </div>

          <!-- Section -->
          <div class="sizeapp__pane__header">
            <strong>{{ $t('moreInfoLegLengthTitle') }}</strong>
          </div>
          <div class="sizeapp__pane__content">
            <ul>
              <li>{{ $t('moreInfoLegLengthStep1') }}</li>
              <li>{{ $t('moreInfoLegLengthStep2') }}</li>
              <li>{{ $t('moreInfoLegLengthStep3') }}</li>
              <li>{{ $t('moreInfoBodyLengthStep4') }}</li>
              <li>{{ $t('moreInfoLegLengthStep5') }}</li>
              <li>{{ $t('moreInfoLegLengthStep6') }}</li>
            </ul>
          </div>
        </div>
      </div>
      <!-- <div class="sizeapp__header">
        <strong class="sizeapp__header__title">Mijn maat berekenen</strong>
        <span class="sizeapp__header__button">&times;</span>
      </div> -->
      <div key="app" class="sizeapp__inner" v-else>
        <!-- Modal image -->
        <div class="sizeapp__model">
          <!-- Indicators -->
          <div
            class="sizeapp__model__indicator sizeapp__model__indicator--legs"
            v-bind:class="{ 'sizeapp__model__indicator--active': active['B'] }">
            <i
              class="sizeapp__model__indicator__arrow sizeapp__model__indicator__arrow--up"></i>
            <i
              class="sizeapp__model__indicator__arrow sizeapp__model__indicator__arrow--down"></i>
            <span>B</span>
            <div
              class="sizeapp__model__indicator__value"
              v-if="innerLegLengthIndicator">
              {{ innerLegLengthIndicator }}
            </div>
          </div>
          <div
            class="sizeapp__model__indicator sizeapp__model__indicator--body"
            v-bind:class="{ 'sizeapp__model__indicator--active': active['A'] }">
            <i
              class="sizeapp__model__indicator__arrow sizeapp__model__indicator__arrow--up"></i>
            <i
              class="sizeapp__model__indicator__arrow sizeapp__model__indicator__arrow--down"></i>
            <span>A</span>
            <div
              class="sizeapp__model__indicator__value"
              v-if="bodyLengthIndicator">
              {{ bodyLengthIndicator }}
            </div>
          </div>

          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000">
            <path
              d="M505.2 570.3c-1.4 17 10.1 107 16.1 142.3 2.8 16.7 10.6 44 7.8 58.4-4 20.2-5.1 46.2-2.9 61.4 1.4 9.2 5.8 51.8-.5 67.3-3.3 8.2-9.3 50-9.3 50-15.6 39.4-6.8 37.5-6.8 37.5 4.8 5.9 13.1.5 13.1.5 6.3 4 10.7-1 10.7-1 5.4 4.5 11.7-.6 11.7-.6 6.8 3.5 13.1-3 13.1-3 3.9 2 4.9-.5 4.9-.5 11.7-.8-6.5-38.2-6.5-38.2-4.4-33.7 4.3-52.4 4.3-52.4 28.5-84.6 30-107 18.6-138.9-3.2-9.2-4-12.8-2.5-16.8 3.4-9.2.9-46.3 5.1-61 8-28.4 16-100.4 20.1-134 5.6-45.3-19.7-106-19.7-106-5.5-24.7 2.6-112.7 2.6-112.7 11.3 17.6 10.9 48.7 10.9 48.7-1.8 32.6 26.3 82.4 26.3 82.4 13.5 20.6 18.6 40.1 18.6 41.5 0 5.9-1.3 20.3-1.3 20.3l.5 12.5c.2 3.2 2 14.1 1.7 19.4-2.1 32.6 3.1 26.5 3.1 26.5 4.4 0 9.2-26.2 9.2-26.2 0 6.8-1.7 27 2 34.6 4.4 9.1 7.6-1.6 7.6-3.7 1.2-41.5 3.6-30.6 3.6-30.6 2.4 33.7 5.4 41.3 10.8 38.6 4-1.9.3-40.4.3-40.4 6.9 22.8 12.2 26.5 12.2 26.5 11.5 8 4.4-14.2 2.8-18.6-8.5-23.4-8.7-31.5-8.7-31.5 10.6 21 18.6 20.2 18.6 20.2 10.3-3.3-9-33-20.4-47.3-5.8-7.3-13.2-17-15.4-22.7-3.5-9.8-6.2-41.2-6.2-41.2-1.1-37.1-10.2-53.2-10.2-53.2-15.7-25.1-18.6-71.9-18.6-71.9l-.7-79c-5.5-53.9-45.2-54.3-45.2-54.3-40.1-6-45.7-18.9-45.7-18.9-8.5-12.2-3.6-35.7-3.6-35.7 7.1-5.7 9.8-21 9.8-21 11.7-9 11.1-22.1 5.7-22-4.3.1-3.4-3.5-3.4-3.5C556.6 13 504 10 504 10h-8s-52.5 3-45.2 62.2c0 0 1 3.6-3.4 3.5-5.4-.1-5.9 13 5.8 22 0 0 2.7 15.2 9.8 21 0 0 4.9 23.5-3.6 35.7 0 0-5.6 13-45.7 18.9 0 0-39.8.4-45.2 54.3l-.8 79s-2.9 46.8-18.6 71.9c0 0-9.1 16.1-10.2 53.2 0 0-2.7 31.4-6.2 41.2-2.1 5.7-9.6 15.5-15.4 22.7-11.4 14.2-30.7 43.9-20.4 47.3 0 0 8 .8 18.6-20.2 0 0-.2 8-8.7 31.5-1.7 4.3-8.7 26.6 2.7 18.6 0 0 5.3-3.6 12.2-26.5 0 0-3.7 38.5.4 40.4 5.4 2.6 8.3-5 10.7-38.6 0 0 2.5-10.9 3.6 30.6.1 2.1 3.2 12.8 7.6 3.7 3.7-7.6 2-27.8 2-34.6 0 0 4.7 26.2 9.2 26.2 0 0 5.2 6.1 3.1-26.5-.3-5.3 1.5-16.3 1.8-19.4l.5-12.5s-1.3-14.3-1.3-20.3c0-1.5 5.1-21 18.6-41.5 0 0 28.1-49.8 26.3-82.4 0 0-.4-31.1 10.9-48.7 0 0 8 88 2.6 112.7 0 0-25.3 60.7-19.7 106 4.1 33.7 12 105.6 20.1 134 4.2 14.7 1.7 51.8 5.1 61 1.5 4 .7 7.7-2.5 16.8-11.3 31.9-9.9 54.3 18.6 138.9 0 0 8.8 18.7 4.3 52.4 0 0-18.2 37.5-6.5 38.2 0 0 .9 2.5 4.9.5 0 0 6.3 6.5 13.1 3 0 0 6.3 5 11.7.5 0 0 4.3 5 10.6 1 0 0 8.3 5.6 13.2-.5 0 0 8.7 1.9-6.8-37.5 0 0-6-41.8-9.2-50-6.3-15.6-1.8-58.2-.5-67.3 2.2-15.3 1-41.3-2.9-61.4-2.9-14.4 4.9-41.7 7.8-58.4 5.9-35.3 17.5-125.3 16.1-142.3l4.8 1.7c3.2 0 5.3-1.7 5.3-1.7z" />
          </svg>
        </div>

        <div class="sizeapp__information">
          <span class="sizeapp__link" v-on:click="toggleHulp()">
            {{ $t('showInformation') }}
          </span>
        </div>

        <!-- Result -->
        <div class="sizeapp__result" v-if="showResult && idealFit">
          <div class="sizeapp__result__primary">
            <small>{{ $t('yourSuggestedSize') }}</small>
            <strong v-if="idealFit"> {{ getLongSize(idealFit) }}</strong>
            <span
              class="sizeapp__link"
              v-on:click="useSizeEvent()"
              v-if="useSize"
              style="margin-top: 8px">
              {{ $t('useSize') }}
            </span>
          </div>

          <div class="sizeapp__result__alternatives" v-if="false">
            <div class="sizeapp__result__alternatives__item">
              <span>{{ $t('sportPosition') }}</span>
              <span>Small (S)</span>
            </div>
            <div class="sizeapp__result__alternatives__item">
              <span>{{ $t('backProblems') }}</span>
              <span>Large (L)</span>
            </div>
          </div>
        </div>

        <!-- Form -->
        <form class="sizeapp__form" v-on:submit.prevent>
          <!-- Type bike -->
          <div class="sizeapp__form__group" v-if="showBikeSelect">
            <label>{{ $t('bikeType') }}</label>
            <div class="sizeapp__form__group__input">
              <select v-model="bikeType">
                <option disabled value="">{{ $t('chooseBikeType') }}</option>
                <option value="gravel">{{ $t('gravel') }}</option>
                <option value="road">{{ $t('road') }}</option>
                <option value="cyclo-cross">{{ $t('cyclo-cross') }}</option>
                <option value="e-bikes">{{ $t('e-bikes') }}</option>
                <option value="fitness">{{ $t('fitness') }}</option>
                <option value="mountainbike">{{ $t('mountainbike') }}</option>
                <option value="triathlon">{{ $t('triathlon') }}</option>
              </select>
            </div>
          </div>

          <div class="sizeapp__preselect" v-if="!showBikeSelect">
            <span
              >{{ $t('youHaveChosen') }}
              <strong>{{ $t(bikeType) }}</strong></span
            >
            <span class="sizeapp__link" v-on:click="setShowBikeSelect(true)">{{
              $t('changeBikeType')
            }}</span>
          </div>

          <div class="sizeapp__form__lengths">
            <!-- Body length -->
            <div class="sizeapp__form__group">
              <label>{{ $t('bodyLengthInCm') }}</label>
              <div class="sizeapp__form__group__input">
                <input
                  placeholder="180"
                  required
                  :min="minLengths.bodyLength.min"
                  :max="minLengths.bodyLength.max"
                  type="number"
                  v-on:focus="toggleActive('A')"
                  v-on:blur="toggleActive('A')"
                  v-model="bodyLength" />
                <div class="sizeapp__form__group__input__indicator">A</div>
              </div>
            </div>

            <!-- Legs length -->
            <div class="sizeapp__form__group">
              <label>{{ $t('innerLegLengthInCm') }}</label>
              <div class="sizeapp__form__group__input">
                <input
                  placeholder="80"
                  required
                  :min="minLengths.innerLegLength.min"
                  :max="minLengths.innerLegLength.max"
                  type="number"
                  v-on:focus="toggleActive('B')"
                  v-on:blur="toggleActive('B')"
                  v-model="innerLegLength" />
                <div class="sizeapp__form__group__input__indicator">B</div>
              </div>
            </div>
          </div>

          <span v-if="!idealFit && showResult" class="sizeapp__form__error">{{
            $t('measuresNotSupported')
          }}</span>

          <!-- Submit button -->
          <button class="sizeapp__button" v-on:click="calculate">
            {{ $t('calculateSize') }}
          </button>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import bodyLengthTable from "./assets/json/OTHER/bodyLength.json";
import innerLegLengthTable from "./assets/json/OTHER/innerLegLength.json";

import bodyLengthTableMTB from "./assets/json/MTB/bodyLength.json";
import innerLegLengthTableMTB from "./assets/json/MTB/innerLegLength.json";

import i18n from "./i18n";

export default {
  i18n,
  name: "sizingWidget",
  props: {
    bikeType: {
      type: String,
      default: "",
    },
    lang: {
      type: String,
      default: "en",
    },
    useSize: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      idealFitValue: "PERFECT",
      almostIdealFitValue: "FRAME_ALMOST_PERFECT", // new
      justToSmallToBePerfect: "FRAME_JUST_TO_SMALL_TO_BE_PERFECT", // new
      sportFitValue: "SPORT_POSTURE",
      aggressiveFitValue: "AGGRESSIVE_POSTURE",
      frameToBigValue: "FRAME_TO_BIG",
      frameVeryLittleToBigValue: "FRAME_VERY_LITTLE_TO_BIG", // new
      frameLittletoToBigValue: "FRAME_LITTLE_TO_BIG",
      frameToSmallValue: "FRAME_TO_SMALL",

      idealFit: "",

      showBikeSelect: true,
      hulp: false,
      showResult: false,
      active: { A: false, B: false },
      bodyLength: undefined,
      innerLegLength: undefined,
      minLengths: {
        innerLegLength: {
          min: 50,
          max: 118,
        },
        bodyLength: {
          min: 150,
          max: 210,
        },
      },

      sizes: ["XXS", "XS", "S", "M", "L", "XL"],

      bodyLengthResult: {
        length: undefined,
        XL: undefined,
        L: undefined,
        M: undefined,
        S: undefined,
        XS: undefined,
        XXS: undefined,
      },

      legLengthResult: {
        length: undefined,
        XL: undefined,
        L: undefined,
        M: undefined,
        S: undefined,
        XS: undefined,
        XXS: undefined,
      },
    };
  },
  mounted() {
    if (this.$i18n) {
        this.$i18n.locale = this.lang; // || 'en'; // default language for development purposes
    }
    this.showBikeSelect = !this.bikeType;
  },
  methods: {
    useSizeEvent() {
      this.$el.dispatchEvent(
        new CustomEvent("use", {
          bubbles: true,
          composed: true,
          detail: this.idealFit,
        })
      );
      console.log("use ", this.idealFit);
    },
    setShowBikeSelect(show) {
      this.showBikeSelect = show;
    },
    toggleHulp() {
      this.hulp = !this.hulp;
    },
    toggleActive(key) {
      this.active[key] = !this.active[key];
    },
    calculate() {
      this.idealFit = "";
      const bodyLengthPriority = [this.idealFitValue, this.sportFitValue];
      const legLengthPriority = [
        this.idealFitValue,
        this.almostIdealFitValue,
        this.justToSmallToBePerfect,
        this.frameVeryLittleToBigValue,
      ];

      // Get the JSON-values
      this.bodyLengthResult = this.getFitByLength();
      this.legLengthResult = this.getFitByLegLength();

      // Get the perfect bodyLength
      for (let i = 0; i < bodyLengthPriority.length; i++) {
        let bodyPriorityItem = bodyLengthPriority[i];

        // Get the perfect legLength
        for (let j = 0; j < legLengthPriority.length; j++) {
          let legPriorityItem = legLengthPriority[j];

          // Get the results based on prio
          let bodyFits = this.getValueFromSizes(
            this.bodyLengthResult,
            bodyPriorityItem
          );
          let legLengthFits = this.getValueFromSizes(
            this.legLengthResult,
            legPriorityItem
          );

          // Check if there are values
          if (bodyFits && legLengthFits) {
            // Check for an intersection
            let intersection = bodyFits.filter((value) =>
              legLengthFits.includes(value)
            );

            // Just 1 intersection
            if (intersection.length == 1) {
              this.idealFit = intersection[0];
              break;

              // More then 2 intersections
            } else if (intersection.length > 1) {
              this.idealFit = this.getSmallestValue(intersection);
              break;
            }
          }
        }

        // Ideal fit found
        if (this.idealFit) {
          break;
        }
      }

      this.showResult = true;
    },
    getSmallestValue(fits) {
      for (let i = 0; i < this.sizes.length; i++) {
        if (fits.indexOf(this.sizes[i]) != -1) {
          return this.sizes[i];
        }
      }
    },
    getValueFromSizes(measurement, fit) {
      let result = [];

      for (let i = 0; i < this.sizes.length; i++) {
        if (measurement[this.sizes[i]] == fit) {
          result.push(this.sizes[i]);
        }
      }

      return result;
    },

    getFitByLength() {
      const table = this.bikeType !== 'MTB' ? bodyLengthTable : bodyLengthTableMTB;
      return table.find((s) => s.size == this.bodyLength);
    },
    getFitByLegLength() {
      const table = this.bikeType !== 'MTB' ? innerLegLengthTable : innerLegLengthTableMTB;
      return table.find(
        (s) => s.size == this.innerLegLength
      );
    },
    getLongSize: function (size) {
      return `${size} (${this.$t(size)})`;
    },
  },
  computed: {
    innerLegLengthIndicator: function () {
      if (
        this.innerLegLength >= this.minLengths.innerLegLength.min &&
        this.innerLegLength <= this.minLengths.innerLegLength.max
      ) {
        return this.innerLegLength;
      }
      return false;
    },
    bodyLengthIndicator: function () {
      if (
        this.bodyLength >= this.minLengths.bodyLength.min &&
        this.bodyLength <= this.minLengths.bodyLength.max
      ) {
        return this.bodyLength;
      }
      return false;
    },
  },
  components: {},
};
</script>
<style lang="scss">
@import './assets/scss/style-complex.scss';
</style>
